import React from 'react';

import InactiveCustomerPage from './inactive-customer-page';

import withDashboardMenuLayout from './layout/withDashboardMenuLayout';

const WrapperInactiveCustomerPage = () => {
  return withDashboardMenuLayout({
    childComponent: (
      <div className="h-full">
        <InactiveCustomerPage />
      </div>
    ),
  });
};

export default WrapperInactiveCustomerPage;
